import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Select from '../../../../components/Select';
import { IsAdmin } from '../../../../utils/Roles';
import validationSchema from './validation';
import ValidatesFormWith from '../../../../utils/ValidatesFormWith';
import Input from '../../../../components/Input';
import Countries from '../../../../utils/Countries';
import UploadFilesField from '../../../../components/UploadFilesField';
import Textarea from '../../../../components/Textarea';
import UploadImageField from '../../../../components/UploadImageField';
import Checkbox from '../../../../components/Checkbox';
import { FREE_PLAN, FULL_PLAN, PRODUCERS_PLAN, VENUES_PLAN } from '../../../../constants';


class TheaterForm extends React.PureComponent {
  onPublishClick = (evt, props) => {
    evt.preventDefault();
    props.setFieldValue('publish', true);
    setTimeout(() => {
      props.submitForm();
    }, 500);
  };

  process = (values) => {
    const theater = {
      name: values.name,
      country: values.country,
      city: values.city,
      address: values.address,
      biography: values.biography,
      website: values.website,
      plan: values.plan,
      facebook: values.facebook,
      director: values.director,
      contact: values.contact,
      email: values.email,
      telephone: values.telephone,
      role: values.role,
      type: values.type,
      features: [],
      publish: values.publish,
      images: values.images.map(image => ({
        url: image.url,
        thumbUrl: image.thumbUrl,
      })),
    };

    if (values.capacity) {
      theater.features.push({
        type: 'text',
        key: 'capacity',
        name: 'Capacidad',
        value: values.capacity,
      });
    }

    values.files.forEach((file) => {
      let { name } = file;
      if ({}.hasOwnProperty.call(file, 'description') && file.description) {
        name = file.description;
      }
      theater.features.push({
        type: 'link',
        name,
        value: file.url || file.value,
      });
    });

    this.props.onSubmit(theater);
  };

  render() {
    const {
      theater,
    } = this.props;

    let capacity = '';
    if (theater.features) {
      const capacityObject = theater.features.find(f => f.name === 'Capacidad') || {};
      capacity = capacityObject.value || '';
    }

    let files = [];
    if (theater.features) {
      files = theater.features.filter(f => f.type === 'link');
    }


    return (
      <Formik
        enableReinitialize
        initialValues={{
          name: theater.name,
          website: theater.website,
          address: theater.address,
          city: theater.city,
          biography: theater.biography,
          capacity: `${capacity}`,
          country: theater.country,
          plan: theater.plan || FREE_PLAN,
          facebook: theater.facebook || '',
          director: theater.director,
          contact: theater.contact,
          email: theater.email,
          telephone: theater.telephone,
          role: theater.role,
          type: theater.type,
          files,
          images: theater.images,
          publish: false,
        }}
        onSubmit={this.process}
        validate={ValidatesFormWith(validationSchema, true)}
        validateOnChange={false}
        render={props => (
          <form onSubmit={props.handleSubmit}>
            {this.props.title && <h1>{this.props.title}</h1>}
            <div className="search-contents-sidebar">
              <div className="row">
                <div className={IsAdmin() ? 'col-md-5' : 'col-md-8'}>
                  <Input
                    label="Nombre"
                    name="name"
                  />
                </div>
                <div className="col-md-4">
                  <Select
                    label="Tipo de institución"
                    name="type"
                    placeholder="Tipo de institución"
                    options={[
                      { value: 'teather', label: 'Teatro' },
                      { value: 'company', label: 'Compañía' },
                      { value: 'festival', label: 'Festival' },
                      { value: 'producer', label: 'Productor' },
                    ]}
                  />
                </div>
                {IsAdmin() && (
                  <div className="col-md-3">
                    <Select
                      label="Plan"
                      name="plan"
                      placeholder="Selecciona tu plan"
                      options={[
                        { value: FREE_PLAN, label: 'Gratis' },
                        { value: PRODUCERS_PLAN, label: 'Producers' },
                        { value: VENUES_PLAN, label: 'Venues' },
                        { value: FULL_PLAN, label: 'Full' },
                      ]}
                    />
                  </div>)}
              </div>
              <div className="row">
                <div className="col-md-5">
                  <Select
                    label="País"
                    name="country"
                    placeholder="Seleccione país"
                    options={Countries}
                  />
                </div>
                <div className="col-md-7">
                  <Input
                    label="Ciudad"
                    name="city"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-9">
                  <Input
                    label="Dirección"
                    name="address"
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    label="Número de butacas"
                    name="capacity"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Sitio web"
                    name="website"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Facebook"
                    name="facebook"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <Input
                    label="Director General"
                    name="director"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <h4>Datos de contacto</h4>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Nombre de contacto"
                    name="contact"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Correo electrónico"
                    name="email"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Teléfono"
                    name="telephone"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Cargo"
                    name="role"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <UploadFilesField
                    pdf
                    label="Archivos técnicos"
                    name="files"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <Textarea
                    label="Biografía"
                    name="biography"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                  <UploadImageField
                    label="Imágenes"
                    name="images"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <label className="margin-t-10">Características</label>
                  <Checkbox
                    hideLabel
                    id="enabledStats"
                    checkLabel="Activar estadísticas"
                    name="enabledStats"
                  />
                </div>
              </div>
              <div className="m-b-md m-t-md">
                <button type="submit" className="book-btn gray">
                  <span className="book-btn-l gray">
                    <i className="fa fa-save" />
                  </span>
                  <span className="book-btn-r">Guardar</span>
                  <div className="clear" />
                </button>

                <button type="submit" onClick={e => this.onPublishClick(e, props)} className="book-btn">
                  <span className="book-btn-l">
                    <i className="fa fa-check" />
                  </span>
                  <span className="book-btn-r">Publicar</span>
                  <div className="clear" />
                </button>
              </div>
            </div>
          </form>
        )}
      />
    );
  }
}

TheaterForm.propTypes = {
  onSubmit: PropTypes.func,
  theater: PropTypes.object,
  title: PropTypes.string,
};

TheaterForm.defaultProps = {
  onSubmit: () => {},
  theater: {},
  title: undefined,
};


export default TheaterForm;



// WEBPACK FOOTER //
// ./src/containers/Admin/Theater/Form/index.js